// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1bvEV","errorLogs":"styles_errorLogs__9VYSO"};